import { actionTypes } from '../constants';
import { redirectPaths } from '../constants/redirectPaths';

const buildParams = params => {
  return Object.entries(params)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
};

const redirectMiddleware = store => next => action => {
  const result = next(action);
  const { config } = store.getState();

  const searchParams = {
    applyFor: config.productCode,
    brandId: config.brandId
  };

  const hashParams = {
    access_token: config.accessToken,
    bankId: config.bankId,
    caseId: config.caseId,
    user_tracking_id: config.userTrackingId,
    accountId: config.accountId,
    reason: config.reason,
    transferRequested: config.transferRequested || ''
  };

  if (
    (window.location.pathname === redirectPaths.HOME_ROUTE && action.isBack) ||
    action.type === actionTypes.REDIRECT_URL
  ) {
    window.location.href = `${config.redirectUrl}/?${buildParams(searchParams)}#${buildParams(
      hashParams
    )}`;
  }

  return result;
};

export default redirectMiddleware;
